module.exports = __webpack_public_path__ + "static/media/icon-plus-green.bbd8f9b8.svg";